/*
 * @Author: huangzq
 * @Date: 2019-09-27 11:34:33
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-09-24 19:57:01
 * @Desc: 营销资料-文章tab项
*/
<template>
  <div class="article-tab">
    <!-- 搜索栏 -->
    <search-line @on-search="onSearch" />

    <div class="infinite-scroll-wrapper">
      <infinite-scroll
        ref="infiniteScroll"
        :api="api"
        @on-load-over="onLoadOver"
      >
        <!-- 写文章 -->
        <div
          class="create-wrapper"
          @click="addItem"
        >
          <mk-iconfont
            icon-class="xinzeng"
            class="plus-icon"
          />
          <div>写案例</div>
        </div>

        <!-- 文章列表 -->
        <item
          v-for="(item,index) in dataList"
          :key="item._id+item.status+item.updateTime"
          :item-data="item"
          :other-api="otherApi"
          :type="type"
          @edit-item="editItem(index, item.sourceType)"
          @delete-item="deleteItem(index)"
          @update-item="itemData=>updateItem(itemData,index)"
        />
      </infinite-scroll>
    </div>
    <!-- <select-type
      v-if="show"
      @cancel="cancel"
    ></select-type> -->
  </div>
</template>

<script>
import { MKMATERIALSVC } from '@api'

import SearchLine from '../common/search-line'
import InfiniteScroll from '@components/infinite-scroll'
import Item from '../common/item'

// import SelectType from '../common/select-type'

export default {
  name: 'ArticleTab',
  components: {
    SearchLine,
    InfiniteScroll,
    Item
    // SelectType
  },
  data () {
    return {
      type: 'case',
      // * 获取列表的接口的相关数据
      api: {
        // 接口方法：必须为Promise对象
        promiseFun: MKMATERIALSVC.CaseApi.caseFindListPartPost,
        // 接口参数；分页参数已经放在infiniteScroll组件里面了，所以这块写除了分页的其他参数
        params: {
          showTags: true
        }
      },

      // 其他接口
      otherApi: {
        delete: MKMATERIALSVC.CaseApi.caseDeleteGet,
        publish: MKMATERIALSVC.CaseApi.caseChangeStatusPost,
        update: MKMATERIALSVC.CaseApi.caseUpdatePost,
        find: MKMATERIALSVC.CaseApi.caseDetailGet,
        statistics: MKMATERIALSVC.CasereportApi.reportCaseFindStatisticsGet
      },

      // * 数据列表
      dataList: [],

      // * 当前窗某块文章数据
      currDialogData: { title: '', rules: [], cover: '', context: '' },
      // * 当前弹窗某块朋友圈数据的下标
      currIndex: -1,

      // *是否展示选择文章框
      show: false
    }
  },
  methods: {
    cancel () {
      this.show = false
    },
    // * 搜索事件：返回最新的搜索条件值，然后执行infinite-scroll组件的获取列表方法
    onSearch (searchParams) {
      this.dataList = []
      this.$refs.infiniteScroll.resetPage(searchParams)
    },

    // * 滚动加载数据完毕，返回新获取的数据
    onLoadOver (list) {
      this.dataList.push(...list)
    },

    /**
     * * 新增某个文章：显示【新增文章】弹窗
     */
    addItem () {
      // this.show = true
      this.$router.push({
        path: '/marketing-content/marketing-data/case'
      })
    },
    /**
     * * 编辑某个文章：显示【编辑文章】弹窗
     */
    async editItem (index, type) {
      this.$router.push({
        path:
            '/marketing-content/marketing-data/case/edit?&id=' +
            this.dataList[index]._id
      })
      // switch (type) {
      //   case 1:
      //     // 原创
      //     this.$router.push({
      //       path:
      //       '/marketing-content/marketing-data/original-article/edit?&id=' +
      //       this.dataList[index]._id
      //     })
      //     break
      //   case 2:
      //     // 微信文章转载
      //     this.$router.push({
      //       path:
      //       '/marketing-content/marketing-data/reprint-article/edit?&id=' +
      //       this.dataList[index]._id
      //     })
      //     break
      //   default:
      //     // 其他文章转载
      //     this.$router.push({
      //       path:
      //       '/marketing-content/marketing-data/reprint-all-article/edit?&id=' +
      //       this.dataList[index]._id
      //     })
      //     break
      // }
    },

    // * 删除某个文章：通过index，使用Array.splice来删除
    deleteItem (index) {
      this.dataList.splice(index, 1)
    },

    /**
     * * 更新某个文章数据：
     * * 有id时：通过id获取最新的数据，然后再更新
     * * 无id时：使用传递过来的数据更新
     */
    async updateItem (itemData, index) {
      if (itemData._id) {
        // 通过接口，重新获取当前id的最新数据
        const res = await this.otherApi.find({
          _id: itemData._id,
          showTags: true
        })
        if (res.success) {
          // 将最新数据放到对应下标的dataList中
          this.$set(this.dataList, index, res.data)
        }
      } else {
        // 不通过接口，更新某个数据
        // 主要针对于状态的改变
        const newItemData = { ...this.dataList[index], ...itemData }
        this.$set(this.dataList, index, newItemData)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.article-tab {
  .infinite-scroll-wrapper {
    flex: 1;
    overflow: hidden;

    .infinite-scroll {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      overflow: auto;
      padding: 0 20px;

      & > div {
        margin-right: 24px;
        margin-bottom: 24px;
      }

      .create-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 260px;
        height: 346px;
        background-color: #fafafa;
        border: 1px dashed #d9d9d9;
        box-sizing: border-box;
        color: #595959;
        font-size: 14px;

        @extend .cursor;

        .plus-icon {
          font-size: 26px;
          margin-bottom: 18px;
        }
      }
    }
  }
}
</style>
